import { render, staticRenderFns } from "./CombinedResultReport.vue?vue&type=template&id=7dc68a4a"
import script from "./CombinedResultReport.vue?vue&type=script&lang=js"
export * from "./CombinedResultReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dc68a4a')) {
      api.createRecord('7dc68a4a', component.options)
    } else {
      api.reload('7dc68a4a', component.options)
    }
    module.hot.accept("./CombinedResultReport.vue?vue&type=template&id=7dc68a4a", function () {
      api.rerender('7dc68a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/exam/CombinedResultReport.vue"
export default component.exports